export default __webpack_public_path__ + "static/banner-client-b3b1b17ffb9efa0d1a7c0c2dc8b5a424.webp";